import { RequiredKeysOf } from 'type-fest'
import { v4 as uuidv4 } from 'uuid'
import { OpalApiComponent, OpalApiRequestBody } from '../../schema'

type RequestAttributes =
  OpalApiRequestBody<'CreateStoryV2'>['data']['attributes']
type RequestRelationships = OpalApiComponent<'V3', 'story'>['relationships']

type OptionalAttributes = Omit<
  OpalApiComponent<'V3', 'story'>['attributes'],
  RequiredKeysOf<RequestAttributes>
>

const defaultAssetReferenceAttributes: OptionalAttributes = {
  description: null,
  color: null,
  is_shared: false,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  legacy_id: '0',
}

export const resourceObject = ({
  attributes,
  relationships,
}: {
  attributes: RequestAttributes
  relationships: RequestRelationships
}): OpalApiComponent<'V3', 'story'> => {
  const id = uuidv4()
  const legacyId = Math.floor(Math.random() * 1000).toString()
  return {
    id: id,
    type: 'story',
    meta: {
      effective_privacy: 'some_but_not_all',
    },
    attributes: {
      ...defaultAssetReferenceAttributes,
      ...attributes,
      description:
        attributes.description ??
        defaultAssetReferenceAttributes.description ??
        null,
      legacy_id: legacyId,
    },
    relationships: {
      ...relationships,
    },
  }
}
